import React, { useEffect, useState } from "react";

const KEY = "cure8r_visitor_count";

export default function HitCounter() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const existing = parseInt(localStorage.getItem(KEY) || "0", 10);
    const base = 13337;
    const next = existing ? existing + 1 : base + Math.floor(Math.random() * 500);
    localStorage.setItem(KEY, String(next));
    setCount(next);
  }, []);
  const digits = String(count).padStart(7, "0").split("");
  return (
    <div className="inline-flex items-center gap-2">
      <span className="font-display text-xs">You are visitor #</span>
      <div className="flex bevel-in p-1 bg-black gap-[1px]">
        {digits.map((d, i) => (
          <span key={i} className="w-5 h-7 grid place-items-center bg-black text-retro-neon font-pixel text-xl leading-none">
            {d}
          </span>
        ))}
      </div>
    </div>
  );
}
